import { Info, Link } from "components/elements";
import { TiVoDeviceOemWarning } from "hooks/tivoDevices";
import { PATHS as TIVO_APPS_PATHS } from "pages/TiVoApps/constants";
import { pathToUrl } from "utils/url";

import { TEXTS } from "../constants";
import styles from "./OemWarnings.scss";

export function OemWarnings({
  warnings,
}: {
  warnings?: TiVoDeviceOemWarning[];
}) {
  const presentationCoverageWarnings = warnings?.filter(
    (warning) =>
      warning.code === "presentation_coverage_gap" &&
      warning.meta?.affectedProviders?.length
  );
  if (!presentationCoverageWarnings?.length) {
    return null;
  }

  return (
    <div>
      {presentationCoverageWarnings.map((warning) => (
        <Info className={styles.warning} type="warning" key={warning.code}>
          <p className={styles.title}>{TEXTS.OEM_WARNING_TITLE}</p>
          <p className={styles.description}>
            {TEXTS.OEM_WARNING_MISSING_PRESENTATION}
          </p>
          <ol className={styles.providers}>
            {warning.meta?.affectedProviders?.map((provider) => (
              <li className={styles.provider} key={provider.id}>
                <Link
                  to={pathToUrl(TIVO_APPS_PATHS.editProvider, {
                    id: provider.id,
                    tabId: "presentation",
                  })}
                >
                  {provider.name}
                </Link>
              </li>
            ))}
          </ol>
        </Info>
      ))}
    </div>
  );
}
